import { gql } from '@apollo/client';

import { contentfulSysIdFragment } from '../../utils/contentful/contentfulQuery';

export const breadcrumbsFragment = gql`
  fragment BreadcrumbsAll on Slug {
    breadcrumbText
    slugParent {
      ...ContentfulSysId
      slug
      breadcrumbText
      slugParent {
        ...ContentfulSysId
        slug
        breadcrumbText
        slugParent {
          ...ContentfulSysId
          slug
          breadcrumbText
        }
      }
    }
  }
  ${contentfulSysIdFragment}
`;

export const breadcrumbsQuery = gql`
  query BreadcrumbsQuery($preview: Boolean!, $locale: String!, $id: String!) {
    slug(preview: $preview, locale: $locale, id: $id) {
      ...ContentfulSysId
      slug
      ...BreadcrumbsAll
    }
  }
  ${contentfulSysIdFragment}
  ${breadcrumbsFragment}
`;
